import { IonContent, IonPage } from '@ionic/react';
import React, { useContext, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import DeviceLogin from '../components/authentication/DeviceLogin';
import { TranslationContext, UserContext } from '../contexts';
import 'swiper/css';
import 'swiper/css/pagination';
import './homepage.scss';

export const HomePage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { isAuthenticated, isExpert } = useContext(UserContext);
  const { translate } = useContext(TranslationContext);

  useEffect(() => {
    // Only try to go back if there is a referrer and it's not this page
    // It is meant to let accept the device id and cookies
    if (
      document.referrer &&
      !document.referrer.endsWith(location.pathname) &&
      window.history.length > 1
    ) {
      history.goBack();
    }
  }, [history, location.pathname]);

  if (isAuthenticated) {
    return (
      <Redirect to={isExpert ? '/expert/dashboard' : '/customer/experts'} />
    );
  }

  return (
    <IonPage>
      <IonContent fullscreen scrollY={false}>
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          speed={400}
          className="ion-slides"
        >
          <SwiperSlide className="small">
            <h2>{translate('home.slides.1.title')}</h2>
            <img src="/assets/img/tutorial/1_reading.png" alt="reading" />
            <p>{translate('home.slides.1.p1')}</p>
            <p>{translate('home.slides.1.p2')}</p>
            <p>
              <span>{translate('home.slides.1.p3Span')}</span>
            </p>

            <DeviceLogin
              text={translate('home.buttons.chatNow')}
              redirect={'/customer/experts'}
            />
          </SwiperSlide>

          <SwiperSlide className="small">
            <h2>{translate('home.slides.2.title')}</h2>
            <img src="/assets/img/tutorial/2_best_psychics.png" alt="chat" />
            <p>{translate('home.slides.2.p1')}</p>
            <p>
              <span>{translate('home.slides.2.p2Span')}</span>
            </p>
            <DeviceLogin
              text={translate('home.buttons.chatNow')}
              redirect={'/customer/experts'}
            />
          </SwiperSlide>

          <SwiperSlide className="small">
            <h2>{translate('home.slides.3.title')}</h2>
            <img src="/assets/img/tutorial/3_chat.png" alt="chat" />
            <ol>
              <li>{translate('home.slides.3.ol.1')}</li>
              <li>{translate('home.slides.3.ol.2')}</li>
              <li>{translate('home.slides.3.ol.3')}</li>
            </ol>
            <DeviceLogin
              text={translate('home.buttons.getStarted')}
              redirect={'/customer/experts'}
            />
          </SwiperSlide>
        </Swiper>
      </IonContent>
    </IonPage>
  );
};
